import { useOrderActivityMutation, useCheckoutToken, useOrderSource } from '../../state'
import { isAppleRetailOrder } from '../../state/checkout/helper'

export const useCallOrderActivity = (): (() => Promise<void>) => {
  const [orderActivity] = useOrderActivityMutation()
  const checkoutToken = useCheckoutToken()
  const orderSource = useOrderSource()

  return async (): Promise<void> => {
    if (isAppleRetailOrder(orderSource)) {
      try {
        await orderActivity({ token: checkoutToken, eventType: 'ORDER_CHECKOUT_ABANDONED' }).unwrap()
      } catch {
        // ignore error
      }
    }
  }
}
